import { useUnit } from 'effector-react';
import style from './ClusterInfoModal.module.css';
import { changeClusterProblemDetailsEv } from '../../models/overviewModel/index.js';
import ClusterProjectTeam from './ClusterProjectTeam.jsx';
import React from 'react';
import MapModalComponent from '../MapModal/MapModalComponent.jsx';
import ProblemTableComponent from '../ProblemTableComponent/ProblemTableComponent.jsx';
import ClusterTargetIndicators from './ClusterTargetIndicators.jsx';

const project_team_data = [
  {
    category: 'juniors',
    cat_ru: 'Представители МСБ',
    members: [
      {
        name: 'ЖАНАСОВ Ермек',
        position: 'Управляющий директор ТОО «Ер-Тай»',
        star: true,
      },
      {
        name: 'САТЫЛГАНОВ Кайрат',
        position: 'Директор ТОО «Караван Ресорсиз ЛТД»',
        star: false,
      },
      {
        name: 'СУЛТАНОВ Саид',
        position:
          'Председатель наблюдательного совета «Aurora Minerals Group LLP»',
        star: false,
      },
    ],
  },
  {
    category: 'majors',
    cat_ru: 'Представители крупного бизнеса',
    members: [
      // {
      //   name: 'НУРИЕВ Нурахмет',
      //   position: 'Председатель Правления ТОО «Корпорация «Казахмыс»',
      //   star: false,
      // },
      // {
      //   name: 'АЛДАНОВ Нурлан',
      //   position: 'Управляющий директор по катодной меди «KAZ Minerals»',
      //   star: false,
      // },
      {
        name: 'ЖАНБОТИН Жанат',
        position: 'Генеральный директор ТОО «Казцинк»',
        star: false,
      },
      {
        name: 'ОГАЙ Эдуард',
        position: 'Председатель совета директоров ТОО «Kazakhmys Holding»',
        star: false,
      },
      {
        name: 'НОВАЧУК Олег',
        position: 'Председатель Совета Директоров Группы KAZ Minerals PLC',
        star: false,
      },
    ],
  },
  {
    category: 'recyclers',
    cat_ru: 'Представители бизнеса по переработке меди',
    members: [
      {
        name: 'РАСПОПИН Виталий',
        position: 'Генеральный директор ТОО «КазЭлектроМаш»',
        star: false,
      },
      {
        name: 'НАБИЕВ Ерлан',
        position: 'Директор ТОО «НЕРОГрупп»',
        star: false,
      },
      {
        name: 'ЦЫМБАЛ Дмитрий',
        position: 'Исполнительный директор АО «Казэнергокабель»',
        star: false,
      },
    ],
  },
];

function ClusterGmkContent(props) {
  const { clusterInfoModal } = props;
  const changeClusterProblemDetails = useUnit(changeClusterProblemDetailsEv);

  return (
    <div>
      {clusterInfoModal === 'target_indicators' && <ClusterTargetIndicators />}
      {clusterInfoModal === 'business_model' && <MapModalComponent />}
      {clusterInfoModal === 'project_team' ? (
        <ClusterProjectTeam data={project_team_data} />
      ) : null}
      {clusterInfoModal === 'top_problems' && <ProblemTableComponent />}
    </div>
  );
}

export default ClusterGmkContent;
